import { render, staticRenderFns } from "./TagCustom.vue?vue&type=template&id=5faf7bca&scoped=true"
import script from "./TagCustom.vue?vue&type=script&lang=js"
export * from "./TagCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faf7bca",
  null
  
)

export default component.exports